import { useProfileContext } from '../contexts/ProfileContext';

export const useProfile = () => {
  const { profile, isLoading, hasProfile, updateProfile, updateMemberProfile } =
    useProfileContext();

  return { profile, updateProfile, isLoading, hasProfile, updateMemberProfile };
};
